import { gql } from '@grandvisionhq/graphql';
import AppointmentFragment from '../fragments/appointment.js';

var GET_MY_APPOINTMENTS = gql`
  query getMyAppointments {
    me {
      id
      appointments {
        ...AppointmentFragment
      }
    }
  }
  ${AppointmentFragment}
`;

export { GET_MY_APPOINTMENTS as default };
//# sourceMappingURL=get-my-appointments.js.map
